import { render, staticRenderFns } from "./ZeroFiling.vue?vue&type=template&id=236c069c&scoped=true&"
import script from "./ZeroFiling.vue?vue&type=script&lang=js&"
export * from "./ZeroFiling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c069c",
  null
  
)

export default component.exports